import React from 'react';
import {getHref} from '../../../../../../../../domain/utils/itemUtils';
import {ICartItem} from '../../../../../../../../types/app.types';
import {useControllerProps, UseControllerPropsResult} from '../../../../../ControllerContext';

export enum ItemLinkDataHooks {
  Anchor = 'ItemLinkDataHooks.Anchor',
}

const handleClick = (
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  navigationStore: UseControllerPropsResult['navigationStore'],
  urlPart: string
) => {
  event.preventDefault();
  event.stopPropagation();
  return navigationStore.navigateToProduct(urlPart);
};

export const ItemLink = ({item, children}: {item: ICartItem; children: React.ReactChild}) => {
  const {cartStore, navigationStore} = useControllerProps();
  const href = getHref(cartStore, item);

  return (
    <a
      href={href}
      onClick={(event) => handleClick(event, navigationStore, item.product.urlPart)}
      data-hook={ItemLinkDataHooks.Anchor}>
      {children}
    </a>
  );
};
